// extracted by mini-css-extract-plugin
module.exports = {"addCardButton":"AddCard_addCardButton__3Dyh_","addCardForm":"AddCard_addCardForm__IGNJ_"};